
<template>
  <!-- ? click  a build, if this build don't have build data open this page  -->
  <div id="newBuildMsgDialog" class="grid">
    <!-- 没有楼栋数据的弹出框 -->
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="el_dialog_style_1"
      title="管理楼栋信息"
      :visible.sync="newbuild"
      width="930px"
      :before-close="newbuildClose"
    >
      <el-form
        :rules="rules"
        :inline="true"
        :model="formInline"
        ref="formInline"
        class="demo-form-inline formstyle"
      >
        <el-form-item label="所属网格" prop="sswg">
          <el-input v-model="formInline.sswg" placeholder="所属网格"></el-input>
        </el-form-item>
        <el-form-item label="网格长" prop="ldbm">
          <el-input v-model="formInline.ldbm" placeholder="网格长"></el-input>
        </el-form-item>

        <el-form-item label="小区名称" prop="xqmc">
          <el-input v-model="formInline.xqmc" placeholder="小区名称"></el-input>
        </el-form-item>

        <el-form-item label="楼栋名称" prop="ldmc">
          <el-input v-model="formInline.ldmc" placeholder="楼栋名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋层数" prop="ldcs">
          <el-input v-model="formInline.ldcs" placeholder="楼栋层数"></el-input>
        </el-form-item>

        <el-form-item label="楼栋单元数" prop="lddys">
          <el-input
            v-model="formInline.lddys"
            placeholder="楼栋单元数"
          ></el-input>
        </el-form-item>
        <el-form-item label="每层户数" prop="mchs">
          <el-input v-model="formInline.mchs" placeholder="每层户数"></el-input>
        </el-form-item>
        <el-form-item class="newuploadsBox" style="marginRight:90px" label="">
          <div class="uploads">
            <span>网格长</span>
          </div>
          <div class="uploads">
            <img
              style="height:95px;"
              src="http://a3.att.hudong.com/05/07/01300001374836131659074715230.jpg"
              alt=""
            />
          </div>
          <div class="uploads doorphoto" @click="up_click_girdhead">
            <input
              type="file"
              value="uploading"
              ref="gird_up"
              id="file2"
              @change="uploadConfiggrid"
            />
            <span class="uoloaddoor">上传楼宇</span>
            <span class="iconfont icon-tianjia1 dooricon"></span>
            <img :src="girduploadfilephoto" alt="" width="100%" height="100%" />
          </div>
        </el-form-item>
      </el-form>
      <!-- ? upload grid head photo -->
      <div class="uploading">
        <el-button @click="submitform" size="small" type="primary"
          >提交表单</el-button
        >
        <el-button @click="resetForm()" size="small" type="primary"
          >清空表单</el-button
        >
        <input
          type="file"
          value="uploading"
          ref="file_up"
          id="file"
          @change="uploadConfig"
        />
        <a
          class="dowmloada"
          :href="url"
          download="w3logo"
          >🌟下载楼宇信息模版</a
        >
        <!-- button点击时,触发input的点击事件 -->
        <button class="oplbtn" @click="up_click">选择文件</button>
        <button class="oplbtn" @click="up_file">上传</button>
        <span class="uplso">{{ this.uploadfilename }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import baseURL from "@/api/baseURL"
export default {
  data() {
    return {
       url:baseURL+
                "/ypt/admin/section/info/downloadSection",
      // ? floor upload photo and file
      girduploadfilephoto: "", // ? show photo
      girduploadfile: "", // ? floor's  e.target.files[0]
      loading: false,
      newbuild: true,

      // 新建表单上传文件的文件名
      uploadfilename: "",
      // ? upload every family's message array file
      senddata: {},

      // 新建楼栋数据表单
      formInline: {},
      // 新建楼栋表单校验
      rules: {
        ldmc: [{ required: true, message: "必填项", trigger: "blur" }],
        ldcs: [{ required: true, message: "必填项", trigger: "blur" }],
        lddys: [{ required: true, message: "必填项", trigger: "blur" }],
        mchs: [{ required: true, message: "必填项", trigger: "blur" }],
        xqmc: [{ required: true, message: "必填项", trigger: "blur" }],
        ssjd: [{ required: true, message: "必填项", trigger: "blur" }],
        ssjwh: [{ required: true, message: "必填项", trigger: "blur" }]
      }
    };
  },
  mounted(){
    // 监听楼栋的点击事件
    
  },
  methods: {
    // 新建楼栋表单的提交按钮
    async submitform() {
      if (
        this.formInline.ldcs == "" ||
        this.formInline.lddys == "" ||
        this.formInline.mchs == ""
      ) {
        this.$message({
          message: "请填写表单信息",
          type: "warning"
        });
        return;
      }
      // ? every famaly's message array
      let doorarr = this.getuserdoor();
      let doorarrjson = JSON.stringify(doorarr);
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.loading = true;
      let formData = new FormData();
      formData.append("sectionMapId", this.formInline.loudongID);
      formData.append("sectionCode", this.formInline.ldbm);
      formData.append("sectionName", this.formInline.ldmc);
      // ?  grid name formData
      formData.append("gridName", this.formInline.sswg);
      formData.append("sectionFloor", this.formInline.ldcs);
      formData.append("sectionCell", this.formInline.lddys);
      formData.append("sectionHouse", this.formInline.mchs);
      formData.append("blockName", this.formInline.xqmc);
      formData.append("sectionFile", this.girduploadfile);
      formData.append("door", doorarrjson);
      let result = await this.$http.post(
        "/admin/section/info/insertSection",
        formData,
        config
      );
      this.$message("提交成功");
      this.newbuild = false;
      this.resetForm();
      this.loading = false;
    },
    // 提交时生成楼栋每一户的信息
    getuserdoor() {
      let id = this.formInline.loudongID; //楼栋id
      let dy = this.formInline.lddys; //楼栋单元数
      let cs = this.formInline.ldcs; //楼栋层数
      let hs = this.formInline.mchs; // 每层户数
      let door = []; //最外层数组
      // 第一层循环,生成单元数组
      for (let dyindex = 0; dyindex < dy; dyindex++) {
        let dys = [];
        // 第二层循环,生成层数
        for (let csindex = 0; csindex < cs; csindex++) {
          let css = [];
          // 第三层循环,生成户
          for (let hsindex = 0; hsindex < hs; hsindex++) {
            let hss = {};
            hss.sectionMapId = id;
            hss.cellNum = dyindex + 1; //单元数
            hss.doorFloor = csindex + 1; //层数
            hss.familyType = 0; //户性质
            //拼门牌号
            let hssind = hsindex + 1;
            hssind = hssind + "";
            if (hssind.length == 1) {
              hssind = "0" + hssind;
            }
            hss.doorCode = hss.doorFloor + "" + hssind;
            //默认门牌号
            hss.doorCodeHide = "part_" + hss.cellNum + "_" + hss.doorCode;
            //户号
            hss.familyCode = id + "part_" + hss.cellNum + "_" + hss.doorCode; //拼户号

            css.push(hss);
            // css = css.reverse();
          }
          dys.push(css);
        }
        dys = dys.reverse();
        door.push(dys);
      }
      return door;
    },

    // ! upload every family's file
    up_click() {
      this.$refs["file_up"].click();
    },
    uploadConfig(e) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      this.uploadfilename = e.target.files[0].name;
      this.senddata = formData;
    },
    // ? upload family's message file
    async up_file() {
      this.loading = true;
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let formData = this.senddata;
      await this.$http.post("/admin/person/info/inSectionExcel", formData, config);
      // this.getarticlelist();
      this.$message("上传成功");
      this.loading = false;
    },

    // ! upload floor's photo button
    up_click_girdhead() {
      this.$refs["gird_up"].click();
    },
    uploadConfiggrid(e) {
      console.log(e.target.files);
      let _this = this;
      let files = e.target.files[0];
      this.girduploadfile = files;
      if (!e || !window.FileReader) return; // 看支持不支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(files); // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this.girduploadfilephoto = this.result;
      };
    },

    // 新建楼栋表单的清空按钮
    resetForm() {
      this.formInline = {};
    },
    // close dailog
    newbuildClose() {
      this.newbuild = false;
      this.formInline = {};
      this.girduploadfilephoto = "";
      this.girduploadfile = "";
    }
  }
};
</script>

<style lang="less" scoped>
// 内嵌表单样式
.formstyle {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .el-form-item {
    .el-input {
      width: 330px;
    }
  }

  // ? new grid head and floor photo upload box
  .newuploadsBox {
    .doorphoto {
      border: 1px dashed #b8b9bb;
      border-radius: 4px;
      position: relative;
      .dooricon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .uoloaddoor {
        position: absolute;
        width: 60px;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
      }
    }
    .uploads {
      overflow: hidden;
      height: 95px;
      display: inline-block;
      &:nth-child(2n + 1) {
        width: 65px;
        overflow: hidden;
      }
      &:nth-child(2n) {
        width: 115px;
      }
    }

    #file2 {
      display: none;
    }
  }
}
#file {
  display: none;
}
.dowmloada {
  height: 31px;
  position: relative;
  background-color: #3ac19f;
  border-radius: 3px;
  border: 0;
  color: #fff;
  margin-left: 5px;
  outline: none;
  transition: all 0.4s ease, border-color 0.4s ease;
  display: inline-block;
  text-decoration: none;
  line-height: 31px;
  padding: 0 8px;
  &:hover {
    background-color: #b94f8a;
  }
}
.oplbtn {
  height: 31px;
  position: relative;
  // top: -2px;
  background-color: #3ac19f;
  border-radius: 3px;
  border: 0;
  color: #fff;
  margin-left: 5px;
  outline: none;
  transition: all 0.4s ease, border-color 0.4s ease;
  &:hover {
    background-color: #d94f8a;
  }
}
.uplso {
  text-align: left;
  margin-left: 20px;
}
</style>